module.exports = fox._r("images/about-stats.jpg", __webpack_public_path__ + "images/about-stats.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/about-stats.jpg
// module id = 1019
// module chunks = 4